// extracted by mini-css-extract-plugin
export default {"container":"brandItem_container__plUaq","imageContainer":"brandItem_imageContainer__Z0F5J"};